import React from 'react';
import Tools from '@/components/Tools';


import BaseClass from '@/pages/BaseClass';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            playVideo: false,
            videoCode: ""
        };
    }

    componentDidMount() {
        this.showInfo();
    }

    showInfo() {
        this.setState({
            showInfo: true
        });
    }

    closeInfo() {
        this.setState({
            showInfo: false
        });
    }

    playVideo(code) {
        // var para = {
        //     name: "http://cqe.wuzhenwang.xyz/profile/course/%E3%80%90001%E3%80%91%E7%AC%AC1%E8%AF%BE%E6%97%B6%EF%BC%9A%E4%B8%93%E4%B8%9A%E4%B8%8E%E9%80%89%E9%A2%98%E4%BB%8B%E7%BB%8D_20230819143544A046.mp4",
        //     code: code,
        //     // url: "http://cqe.wuzhenwang.xyz/profile/course/%E3%80%90001%E3%80%91%E7%AC%AC1%E8%AF%BE%E6%97%B6%EF%BC%9A%E4%B8%93%E4%B8%9A%E4%B8%8E%E9%80%89%E9%A2%98%E4%BB%8B%E7%BB%8D_20230819143544A046.mp4"
        // }
        // NiceModal.show(MyModal, para);

        // var url = "http://cqe.wuzhenwang.xyz/profile/course/";
        this.setState({
            playVideo: true,
            videoCode: code
        });
    }

    closeVideo() {
        this.setState({
            playVideo: false,
            videoCode: ""
        });
    }

    render() {
        return (
            <>
                <div className="index-page">
                    <div className="index-page-box">
                        <div className="title">
                            <div className="title-main">学习流程</div>
                            <div className="title-sub">轻松五步，高质量完成研学通用</div>
                        </div>
                        <div className="content first">
                            <img src={require('@/assets/images/home/01.png')}/>
                        </div>
                    </div>
                    <hr className="index-page-split"/>
                    <div className="index-page-box mouse-hover">
                        <div className="title">
                            <div className="title-main">平台使用教程</div>
                            <div className="title-sub">从课题选择到成果下载，快速上手</div>
                        </div>
                        <div className="content">
                            <div className="content-sub">
                                <img src={require('@/assets/images/home/02_01.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_01.mp4')}/>
                                <img className="img-center" src={require('@/assets/images/home/02_02.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_02.mp4')}/>
                                <img src={require('@/assets/images/home/02_03.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_03.mp4')}/>
                            </div>
                            <div className="content-sub">
                                <img src={require('@/assets/images/home/02_04.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_04.mp4')}/>
                                <img className="img-center" src={require('@/assets/images/home/02_05.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_05.mp4')}/>
                                <img src={require('@/assets/images/home/02_06.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/02_06.mp4')}/>
                            </div>
                        </div>
                    </div>
                    <hr className="index-page-split"/>
                    <div className="index-page-box mouse-hover">
                        <div className="title">
                            <div className="title-main">研究性学习指导</div>
                            <div className="title-sub">从研究方向到研究报告，分布指导</div>
                        </div>
                        <div className="content">
                            <div className="content-sub">
                                <img src={require('@/assets/images/home/03_01.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_01.mp4')}/>
                                <img className="img-center" src={require('@/assets/images/home/03_02.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_02.mp4')}/>
                                <img src={require('@/assets/images/home/03_03.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_03.mp4')}/>
                            </div>
                            <div className="content-sub">
                                <img src={require('@/assets/images/home/03_04.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_04.mp4')}/>
                                <img className="img-center" src={require('@/assets/images/home/03_05.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_05.mp4')}/>
                                <img src={require('@/assets/images/home/03_06.png')}
                                     onClick={() => this.playVideo('/profile/download/home/video/03_06.mp4')}/>
                            </div>
                        </div>
                    </div>
                    <hr className="index-page-split"/>
                    <div className="index-page-box mouse-hover">
                        <div className="title">
                            <div className="title-main">辅助资料</div>
                            <div className="title-sub">点击下载研学指导资料</div>
                        </div>
                        <div className="content">
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/1.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/1.jpg')}/>
                                    <div className="text">如何确定研究课题方向</div>
                                </a>
                            </div>
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/2.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/2.jpg')}/>
                                    <div className="text">如何确定课题研究方法</div>
                                </a>
                            </div>
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/3.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/3.jpg')}/>
                                    <div className="text">如何查找所需文献资料</div>
                                </a>
                            </div>
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/4.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/4.jpg')}/>
                                    <div className="text">如何制定课题研究方案</div>
                                </a>
                            </div>
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/5.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/5.jpg')}/>
                                    <div className="text">如何实施课题研究方案</div>
                                </a>
                            </div>
                            <div className="pdf">
                                <a href="/profile/download/home/pdf/6.pdf" target="_blank">
                                    <img src={require('@/assets/images/home/pdf/6.jpg')}/>
                                    <div className="text">如何进行课题成果展示</div>
                                </a>
                            </div>
                        </div>
                    </div>

                    {this.state.playVideo && (
                        <>
                            <div className="mask"></div>
                            <div className="modal">
                                <div className="modal-box">
                                    <div className="modal-title">
                                        <a href="javascript:;" className="close" onClick={() => this.closeVideo()}>
                                            <span className="clips close-ico"></span>
                                        </a>
                                    </div>
                                    <div className="modal-body">
                                        <video width="720px" src={this.state.videoCode} autoPlay controls></video>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <Tools/>

            </>
        );
    }
}


